<template>
  <div class="content">
    <div class="class-box">
      <div class="parent-class">
        <div class="left">题库分类：</div>
        <div class="right">
          <div
            class="parent-item"
            v-for="item in parentLists"
            :key="item.id"
            :class="{active:parentId == item.id}"
            @click="parentSelected(item)"
          >{{item.title}}</div>
        </div>
      </div>
      <div class="childrens">
        <div
          class="childrens-item"
          v-for="item in childrens"
          :key="item.id"
          :class="{active:childrensId == item.id}"
          @click="childrensSeletced(item)"
        >{{item.title}}</div>
      </div>
    </div>
    <div class="fixed-box">
      <div
        class="fix-item"
        :class="{active:sign == item.sign}"
        v-for="item in fixList"
        :key="item.sign"
        @click="classify(item.sign)"
      >{{item.name}}</div>
    </div>
    <div class="item-box">
      <div class="changetype" v-show="sign == 6">
        <a-radio-group :value="type"  @change="handleSizeChange">
          <a-radio-button value="1">章节</a-radio-button>
          <a-radio-button value="2">考试</a-radio-button>
        </a-radio-group>
      </div>
      <div class="changetype" v-show="sign == 2">
        <a-radio-group :value="type"  @change="handleSizeChangeTrue">
          <a-radio-button value="1">仿真模拟卷</a-radio-button>
          <a-radio-button value="2">核心预测卷</a-radio-button>
        </a-radio-group>
      </div>
      <mix @treeItemClick="treeItemClick" :list="list" :sign="sign" />
      <!-- <div class="page" v-if="sign == 4">
        <a-pagination
          :defaultCurrent="1"
          :size="'small'"
          :current="current"
          :defaultPageSize="2"
          :total="total_num"
          @change="changePage"
        />
      </div> -->
    </div>
    <a-alert :message="errmsg" v-if="errshow" class="errshow" type="error" showIcon />
  </div>
</template>
<script>
import { getCookie, group_sign } from '../../utils/tool'
import mix from "@/views/page/components/mix-tree";
export default {
  components: { mix },
  data() {
    return {
      parentList: [],
      childrens: [],
      fixList: [
        {
          name: "题库练习",
          sign: 0
        },
        {
          name: "每日一练",
          sign: 1
        },
        {
          name: "套卷训练",
          sign: 2
        },
        {
          name: "模拟考场",
          sign: 3
        },
        {
          name: "错题回顾",
          sign: 4
        },
        {
          name: "试题收藏",
          sign: 5
        },
        {
          name: "练习记录",
          sign: 6
        }
      ],
      list: [],
      sign: -1,
      parentId: -1,
      childrensId: -1,
      type: "1",
      topId:Number(getCookie('top_category_id')),
      account_id:Number(getCookie('account_id')),
      student_id: Number(getCookie('studentId')),
      st_course_id:'',
      howToast: false,
      errshow: false,
      errmsg: "",
      chapterId:'',
      partId:'',
      current: 1,
      total_num: 0
    };
  },
  computed: {
    parentLists: function(){
      return this.sortKey(this.parentList,'order_num')
    },
    childrenss: function(){
      return this.sortKey(this.childrens,'order_num')
    }
  },
  methods: {
    sortKey(arr, key){
      return arr.sort(function(a, b){
        var x = a[key];
        var y = b[key];
        return ((x<y)?-1:(x>y)?1:0)
      })
    },
    menuList(list) {
      let arr1 = [], num = 0;
      for(let i =0; i<list.length; i++) {
        if (i % 2 == 0 && i!=0) {
          arr1.push(list.slice(num, i));
          num = i;
        }
        if (i+1==list.length) {
          arr1.push(list.slice(num,(i+1)))
        }
        // let numb = index + 1;
        // arr1.push(numb);
        // if (numb % 2 == 0 || numb == list.length) {
        //   arr2.push(arr1);
        //   arr1 = [];
        // }
      }
      this.list = arr1[0]
      this.parentPage = arr1;
    },
    changePage(page, pageSize) {
      this.list = this.parentPage[page - 1];
    },
    cycleErr(list) {
      for (let i = 0; i < list.length; i++) {
        let item = list[i];
        item.is_err = true;
        if (item.childrens && item.childrens.length > 0) {
          item.childrens = this.cycleErr(item.childrens);
        }
        if (item.exams && item.exams.length > 0) {
          item.menu = true;
          item.exams = this.cycleErr(item.exams);
        }
      }
      return list;
    },
    cycleExam(list) {
      for (let i = 0; i < list.length; i++) {
        let item = list[i];
        item.is_exam = true;
        if (item.childrens && item.childrens.length > 0) {
          item.childrens = this.cycleExam(item.childrens);
        }
        if (item.exams && item.exams.length > 0) {
          item.exams = this.cycleExam(item.exams);
        }
      }
      return list;
    },
    cycleCet(list) {
      for (let i = 0; i < list.length; i++) {
        let item = list[i];
        item.is_cet = true;
        if (item.childrens && item.childrens.length > 0) {
          item.childrens = this.cycleCet(item.childrens);
        }
        if (item.exams && item.exams.length > 0) {
          item.menu = true;
          item.exams = this.cycleCet(item.exams);
        }
      }
      return list;
    },
    cycleHis(list) {
      try {
        for (let i = 0; i < list.length; i++) {
          let item = list[i];
          item.is_his = true;
          if (item.childrens && item.childrens.length > 0) {
            item.childrens = this.cycleHis(item.childrens);
          }
          if (item.exams && item.exams.length > 0) {
            item.exams = this.cycleHis(item.exams);
          }
        }
      } catch (e) {
        console.error(e);
        //TODO handle the exception
      }

      return list;
    },
    // 获取分类
    getChapter() {
      var param = group_sign({account_id: this.account_id,top_category_id: this.topId,tiku_show:1})
      this.$axios.post(this.$Api.apiGetClassifyList, param).then(
        sccesss => {
          let res = sccesss.data.result;
          for (let i in res) {
            if (res[i].children != null) {
              this.parentList.push(res[i])
            }
          }
          this.parentList = this.sortKey(this.parentList,'order_num')
          this.parentSelected(this.parentList[0]);
        }
      ).catch(error => {console.log(error, ">>>>>>>>>"); });
    },
    // 真题
    getExam(qtype, course_id) {
      var param = group_sign({account_id:this.account_id,category_id:course_id,types:qtype})
      this.$axios.post(this.$Api.clientGetTestPaperList,param).then(
        res => {
          if (res.data.errcode == 0) {
            if (qtype == 1) {
              this.list = res.data.result.quanzhenmoni
            } else if(qtype == 2) {
              this.list = res.data.result.jingzhunyati
            } else {
              this.list = res.data.result.monikaochang
            }
          } else if(res.data.errcode == 403) {
            this.errshow = true;
            this.errmsg = res.data.errmsg;
            let timeError = setTimeout(() => {
              this.errmsg = "";
              this.errshow = false;
              clearTimeout(timeError);
            }, 2000);
            let timeErrors = setTimeout(() => {
              this.$root.Bus.$emit("showLogin")
              clearTimeout(timeErrors)
            }, 2000)
          } else {
            this.errshow = true;
            this.errmsg = res.data.errmsg;
            let timeError = setTimeout(() => {
              this.errmsg = "";
              this.errshow = false;
              clearTimeout(timeError);
            }, 2000);
          }
          
        }
      )
    },
    // 练习记录
    getHistory(course_id, type) {
      var param = group_sign({account_id:this.account_id,student_id:this.student_id,category_id:course_id})
      this.$axios.post(this.$Api.apiGetpracticeRecords,param).then(
        res => {
          if (res.data.errcode == 0) {
            let data = res.data.result.questionPaperList;
            let datas = res.data.result.testPaperList;
            if (type == 2) {
              this.list = datas
            } else {
              this.list = data;
            }
          } else if(res.data.errcode == 403) {
            this.errshow = true;
            this.errmsg = res.data.errmsg;
            let timeError = setTimeout(() => {
              this.errmsg = "";
              this.errshow = false;
              clearTimeout(timeError);
            }, 2000);
            let timeErrors = setTimeout(() => {
              this.$root.Bus.$emit("showLogin")
              clearTimeout(timeErrors)
            }, 2000)
          } else {
            this.errshow = true;
            this.errmsg = res.data.errmsg;
            let timeError = setTimeout(() => {
              this.errmsg = "";
              this.errshow = false;
              clearTimeout(timeError);
            }, 2000);
          }
          
        }
      )
    },
    // 错题本试题集
    getErr() {
      var param = group_sign({account_id:this.account_id,student_id:this.student_id})
      this.$axios.post(this.$Api.getErrorQuestionPaper,param).then(
        res => {
          if (res.data.errcode == 0) {
            let data = res.data.result;
            this.list = data;
            // this.total_num = data.length
            // this.menuList(data)
          } else if(res.data.errcode == 403) {
            this.errshow = true;
            this.errmsg = res.data.errmsg;
            let timeError = setTimeout(() => {
              this.errmsg = "";
              this.errshow = false;
              clearTimeout(timeError);
            }, 2000);
            let timeErrors = setTimeout(() => {
              this.$root.Bus.$emit("showLogin")
              clearTimeout(timeErrors)
            }, 2000)
          } else {
            this.errshow = true;
            this.errmsg = res.data.errmsg;
            let timeError = setTimeout(() => {
              this.errmsg = "";
              this.errshow = false;
              clearTimeout(timeError);
            }, 2000);
          }
          
        }
      )
    },
    //选择分类
    parentSelected(item) {
      if (this.parentId != item.id) {
        this.parentId = item.id;
        this.childrens = this.sortKey(item.children,'order_num');
        this.childrensId = -1;
        this.childrensSeletced(this.childrens[0]);
      }
    },
    childrensSeletced(item) {
      if (this.childrensId != item.id) {
        this.childrensId = item.id;
        this.sign = -1;
        this.classify(0);
      }
    },
    classify(sign) {
      if (this.sign != sign) {
        this.sign = sign;
        switch (sign) {
          case 0: //题库练习
            this.getTree();
            break;
          case 1: //每日一练
            this.$router.push({
              path: "/page/question/quiz",
              query: {
                id: this.childrensId,
                sign: this.sign,
                paperclass: 1,
                qtype: 1,
                name: "每日一练"
              }
            });
            break;
          case 2:
            this.getExam(1, this.childrensId);
            break;
          case 3:
            this.getExam(4, this.childrensId);
            break;
          case 4: //错题本
            this.getErr(this.childrensId);
            break;
          case 5: //收藏试题
            this.$router.push({
              path: "/page/question/quiz",
              query: {
                id: this.childrensId,
                sign: this.sign,
                paperclass: 1,
                qtype: 1,
                name: "试题收藏"
              }
            });
            // this.getColect(this.childrensId);
            break;
          case 6: // 练习记录
            this.getHistory(this.childrensId);
            break;
        }
      }
    },
    cycle(list) {
        let item = list;
        if (item.papers && item.papers.length > 0) {
          // item.menu = true;
          item.papers = this.cycle(item.papers);
        }
        if (item.children && item.children.length > 0) {
          item.children = this.cycle(item.children);
        }
      return list;
    },
    treeItemClick(item) {
      let that = this
      if (item.all_num == 0 && item.question_num == 0 && item.error_num == 0) {
        that.errmsg = '该试题集下暂无试题';
        that.errshow = true;
        let timeErrzz = setTimeout(() => {
          that.errshow = false;
          that.errmsg = "";
          clearTimeout(timeErrzz);
        }, 2000);
      } else {
        if (item.parentId.length == 3) {
          this.chapterId = item.parentId[item.parentId.length -2]
          this.partId = item.parentId[item.parentId.length -1]
        } else if(item.parentId.length == 2) {
          this.chapterId = item.parentId[item.parentId.length -1]
          this.partId = 0
        } else {
          this.partId = 0;
          this.chapterId = 0;
        }
        // console.log(item);
        
        var param =group_sign({account_id:this.account_id,paper_id:item.id,student_id:this.student_id,
        st_course_id:this.sign != 4 ? this.st_course_id: (item.course_id == 0 ? this.st_course_id:item.course_id)})
        if (this.sign == 4 || this.sign == 6) {
          this.$router.push({
                  path: "/page/question/quiz",
                  query: {
                    id: item.id,
                    sign: this.sign,
                    paperclass: 1,
                    qtype: 1,
                    name: item.name,
                    course_id:this.sign != 4 ? this.st_course_id: (item.course_id == 0 ? this.st_course_id:item.course_id),
                    chapterId: this.chapterId,
                    partId: this.partId
                  }
                });
        } else {
          this.$axios.post(this.$Api.apiPaperCheck,param).then(
            res => {
              if (res.data.errcode == 0 && res.data.result.is_auth == 1) {
                if (this.sign != 2 && this.sign != 3) {
                  this.$router.push({
                    path: "/page/question/quiz",
                    query: {
                      id: item.id,
                      sign: this.sign,
                      paperclass: 1,
                      qtype: 1,
                      name: item.name,
                      course_id:this.sign != 4 ? this.st_course_id: (item.course_id == 0 ? this.st_course_id:item.course_id),
                      chapterId: this.chapterId,
                      partId: this.partId
                    }
                  });
                } else if (this.sign == 2) {
                  this.$router.push({
                    path: "/page/question/quiz",
                    query: {
                      id: item.id,
                      sign: this.sign,
                      paperclass: 1,
                      qtype: 2,
                      name: item.name,
                      course_id:this.sign != 4 ? this.st_course_id: (item.course_id == 0 ? this.st_course_id:item.course_id),
                      chapterId: this.parentId
                    }
                  });
                } else if (this.sign == 3) {
                  var params = group_sign({account_id: this.account_id,paper_id: item.id,st_course_id:this.sign != 4 ? this.st_course_id: (item.course_id == 0 ? this.st_course_id:item.course_id),student_id: this.student_id})
                  this.$axios.post(this.$Api.saveExamPaperRecord,params).then(
                    res => {
                      let exam_id = res.data.result;
                      if (exam_id.is_auth == undefined) {
                        this.$router.push({
                          path: "/page/question/quiz",
                          query: {
                            id: item.id,
                            sign: this.sign,
                            paperclass: 1,
                            qtype: 3,
                            name: item.name,
                            course_id:this.sign != 4 ? this.st_course_id: (item.course_id == 0 ? this.st_course_id:item.course_id),
                            chapterId: this.parentId,
                            exam_id: exam_id
                          }
                        });
                      } else if(exam_id.is_auth == 0) {
                        that.errshow = true;
                        that.errmsg = res.data.errmsg;
                        let timeError = setTimeout(() => {
                          that.errmsg = "";
                          that.errshow = false;
                          clearTimeout(timeError);
                        }, 2000);
                      }
                    }
                  )
                  
                }
              } else {
                this.errmsg = res.data.errmsg;
                this.errshow = true;
                let timeErrzz = setTimeout(() => {
                  this.errshow = false;
                  this.errmsg = "";
                  clearTimeout(timeErrzz);
                }, 2000);
              }
            }
          )
        }
        
      }
      
      
    },
    //获取题库试题
    getTree() {
      var param = group_sign({account_id:this.account_id,category_id:this.childrensId,student_id:this.student_id})
      this.$axios.post(this.$Api.apiGetPaperList, param).then(
        res => {
          if (res.data.errcode == 0) {
            let arr = res.data.result;
            let target = [];
            target.push(arr)
            // Object.assign(target,res.data.result)
            this.list = this.cycle(target);
            this.st_course_id = arr.id;
          } else if(res.data.errcode == 403) {
            this.errshow = true;
            this.errmsg = res.data.errmsg;
            let timeError = setTimeout(() => {
              this.errmsg = "";
              this.errshow = false;
              clearTimeout(timeError);
            }, 2000);
            let timeErrors = setTimeout(() => {
              this.$root.Bus.$emit("showLogin")
              clearTimeout(timeErrors)
            }, 2000)
          } else {
            this.errshow = true;
            this.errmsg = res.data.errmsg;
            let timeError = setTimeout(() => {
              this.errmsg = "";
              this.errshow = false;
              clearTimeout(timeError);
            }, 2000);
          }
          
        }
      ).catch(error => {console.log(error, ">>>>>>>>>"); });
    },
    handleSizeChange(e) {
      if (this.type != e.target.value) {
        this.type = e.target.value;
        this.getHistory(this.childrensId,this.type);
      }
    },
    handleSizeChangeTrue(e) {
      if (this.type != e.target.value) {
        this.type = e.target.value;
        this.getExam(this.type,this.childrensId);
      }
    }
  },
  beforeMount() {
    this.getChapter();
  }
};
</script>
<style lang="less" scoped>
@import url('../../assets/less/questtion.less');
</style>
